import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Rewind = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.132.857c-.4-.2-.798-.1-1.097.2L23.096 20.039V1.456c0-.4-.299-.799-.598-.999-.498-.1-.897 0-1.196.3L.569 21.537c-.2.2-.3.5-.3.7 0 .3.1.5.3.7l20.733 20.78c.299.3.797.4 1.096.2.399-.2.598-.5.598-1V25.134l18.94 18.982c.298.3.797.4 1.096.2.399-.2.698-.5.698-1V1.857c0-.4-.2-.8-.598-.999ZM21.002 40.52 2.763 22.236l18.24-18.183v36.465Zm20.634.3L23.495 22.635 41.636 4.354v36.465Z"
  }));
});
Rewind.displayName = 'Rewind';
Rewind.defaultProps = {
  'aria-label': 'Rewind'
};
export default Rewind;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Rewind.js
// module id = 3269
// module chunks = 11